import { render } from "./user.vue?vue&type=template&id=6b0877c4&scoped=true"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"

import "./user.vue?vue&type=style&index=0&id=6b0877c4&lang=less&scoped=true"
import "./user.vue?vue&type=style&index=1&id=6b0877c4&lang=less"
script.render = render
script.__scopeId = "data-v-6b0877c4"

export default script